import React, { useState } from 'react'
import { Box, Hidden } from '@material-ui/core'
import styled from 'styled-components'
import {
  Button,
  Typography,
  SWAPSpace,
  useBreakpoints,
  Paper,
  Banner,
  Chip,
  TextField,
} from '@yosgo/swap-ui'

import { BizPricingHead } from '../Common/PagesHead'

import BizAuthModal from '../Common/BizAuthModal'
import axios from 'axios'

const userBaseIcon = 'https://swap-img.swap.work/landingPageImg/People.svg'

const Pricing = () => {
  const [isOpenAuthModal, setIsOpenAuthModal] = useState(false)
  const [amount, setAmount] = useState(Number)
  const [calc, setCalc] = useState(false)

  const matchesSM = useBreakpoints('sm')
  const matchesXS = useBreakpoints('xs')
  const isDesktop = useBreakpoints('md')
  const [infomation, setInfomation]: any = useState({
    company: '',
    email: '',
    name: '',
    role: '',
    phone: '',
  })
  const [loading, setLoading] = useState(false)
  const [submitBanner, setSubmitBanner] = useState(false)
  const [verified, setVerified] = useState({
    company: false,
    email: false,
  })
  const handleEmailValidation = (email: string) => {
    let re =
      /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    return re.test(String(email).toLowerCase())
  }
  const handleSubmit = async () => {
    setSubmitBanner(false)
    setVerified({
      email: !handleEmailValidation(infomation.email),
      company: !infomation.company || infomation.company.length === 0,
    })
    if (handleEmailValidation(infomation.email) && infomation.company) {
      setLoading(true)
      await axios({
        method: 'POST',
        url: '/api/email',
        data: {
          to: 'swap@yosgo.com',
          subject: 'SWAP 企業版客戶聯繫',
          text: `
<p>公司名稱：${infomation.company}<br />
聯絡信箱：${infomation.email}<br />
姓名：${infomation.name ? infomation.name : '未填寫'}<br />
職稱：${infomation.role ? infomation.role : '未填寫'}<br />
聯絡電話：${infomation.phone ? infomation.phone : '未填寫'}<br />
每個月平均發放的勞務報酬金額：${amount ? amount : '未填寫'}</p>
`,
        },
      })
      await axios({
        method: 'POST',
        url: '/api/email',
        data: {
          to: infomation.email,
          subject: 'SWAP 企業版 聯繫通知',
          text: `
<p>您好 ${infomation.company}<br />
感謝您預約 SWAP 企業版的諮詢，我們已收到您的資訊，業務人員將主動聯繫您。<br />
祝順心</p>
`,
        },
      })
      setLoading(false)
      setInfomation({
        company: '',
        email: '',
        name: '',
        role: '',
        phone: '',
      })
      setSubmitBanner(true)
    }
  }
  return (
    <Hidden implementation="css">
      <BizPricingHead />
      <PricingWrap>
        <BizAuthModal
          open={isOpenAuthModal}
          onClose={() => setIsOpenAuthModal(false)}
          type="register"
        />
        {/* Desktop */}
        <Hidden implementation="css" smDown>
          <img
            src="https://swap-img.swap.work/media/faq_topwave.svg"
            width="100%"
          />
          <Box padding="27px 16px 38px 16px" margin="0 auto" maxWidth={902}>
            <Typography variant="h2">價格方案</Typography>
            <SWAPSpace size="m" />
            <Typography variant="body1" color="black800">
              收費採依量計價方式，無論公司規模大小都可靈活運用！
            </Typography>
          </Box>
        </Hidden>
        {/* Mobile */}
        <Hidden implementation="css" mdUp>
          <Box display="flex" justifyContent="center">
            <Box
              padding={
                matchesSM
                  ? '24px'
                  : matchesXS
                  ? '24px 16px 16px 16px'
                  : '24px 8px 8px 8px'
              }
              width="100%"
            >
              <Typography variant="h4">價格方案</Typography>
              <SWAPSpace size="xs" />
              <Typography variant="body1" color="black800">
                收費採依量計價方式，無論公司規模大小都可靈活運用！
              </Typography>
              <SWAPSpace size="l" />
            </Box>
          </Box>
        </Hidden>
      </PricingWrap>
      <PricingBlock>
        <Paper height="auto">
          <Banner
            style={{
              marginBottom: 16,
            }}
          >
            收費方式為一次性的系統設定費 10,000 元，以及每花費 4,000
            元可以購買一個 Token，每個 Token 可發放 250,000 元的勞務報酬。
          </Banner>
          <Box display="flex" flexDirection={isDesktop ? 'row' : 'column'}>
            <Box width="100%" marginRight={isDesktop ? '8px' : 0}>
              <PricingItem>
                <Box display="flex" alignItems="center">
                  <Box textAlign="center">
                    <Typography
                      style={{ minWidth: !matchesXS && !isDesktop ? 57 : 100 }}
                      variant="body1"
                      color="black900"
                    >
                      初次啟用服務
                    </Typography>
                  </Box>
                  <div
                    style={{
                      height: '52px',
                      width: '1px',
                      margin: '0px 12px',
                      backgroundColor: '#ccc',
                    }}
                  ></div>
                  <Box marginLeft={isDesktop ? '12px' : '6px'}>
                    <Typography variant="subtitle">系統設定費</Typography>
                    <Typography
                      variant="body1"
                      style={{ minWidth: 117, fontSize: 20, marginTop: 4 }}
                    >
                      10,000 TWD
                    </Typography>
                  </Box>
                </Box>
              </PricingItem>
            </Box>
            <Box
              width="100%"
              marginLeft={isDesktop ? '8px' : 0}
              marginTop={isDesktop ? 0 : '16px'}
            >
              <PricingItem>
                <Box display="flex" alignItems="center">
                  <Box textAlign="center">
                    <Typography
                      style={{ minWidth: !matchesXS && !isDesktop ? 57 : 100 }}
                      variant="body1"
                      color="black900"
                    >
                      Token / 1個
                    </Typography>
                  </Box>
                  <div
                    style={{
                      height: '52px',
                      width: '1px',
                      margin: '0px 12px',
                      backgroundColor: '#ccc',
                    }}
                  ></div>
                  <Box marginLeft="12px">
                    <Typography variant="subtitle">購買費用</Typography>
                    <Typography
                      variant="body1"
                      style={{ minWidth: 117, fontSize: 20, marginTop: 4 }}
                    >
                      4,000 TWD
                    </Typography>
                  </Box>
                </Box>
              </PricingItem>
            </Box>
          </Box>
          <Box marginTop="28px">
            <table className="price-table">
              <thead>
                <tr>
                  <th>系統設定費</th>
                  <th>Token</th>
                  <th>購買費用</th>
                  <th>可發放額度</th>
                  <th>總費用(TWD)</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  {isDesktop && (
                    <td
                      rowSpan={3}
                      style={{
                        textAlign: 'center',
                        borderRight: '1px #ececec solid',
                      }}
                    >
                      <Typography variant="body2" color="black800">
                        10,000 TWD
                        <br />
                        (初次使用收取)
                      </Typography>
                    </td>
                  )}
                  <td title="Token">
                    <Typography variant="body2" color="black800">
                      1 個
                    </Typography>
                  </td>
                  <td title="購買費用">
                    <Typography variant="body2" color="black800">
                      4,000
                    </Typography>
                  </td>
                  <td title="可發放額度">
                    <Typography variant="body2" color="primary500">
                      250,000
                    </Typography>
                  </td>
                  {!isDesktop && (
                    <td title="系統設定費">
                      <Typography variant="body2" color="black800">
                        10,000
                      </Typography>
                    </td>
                  )}
                  <td title="總費用">
                    <Typography variant="body2" color="black800">
                      14,000
                    </Typography>
                  </td>
                </tr>
                <tr>
                  <td title="Token">
                    <Typography variant="body2" color="black800">
                      2 個
                    </Typography>
                  </td>
                  <td title="購買費用">
                    <Typography variant="body2" color="black800">
                      8,000
                    </Typography>
                  </td>
                  <td title="可發放額度">
                    <Typography variant="body2" color="primary500">
                      500,000
                    </Typography>
                  </td>
                  {!isDesktop && (
                    <td title="系統設定費">
                      <Typography variant="body2" color="black800">
                        10,000
                      </Typography>
                    </td>
                  )}
                  <td title="總費用">
                    <Typography variant="body2" color="black800">
                      18,000
                    </Typography>
                  </td>
                </tr>
                <tr>
                  <td title="Token">
                    <Typography variant="body2" color="black800">
                      3 個
                    </Typography>
                  </td>
                  <td title="購買費用">
                    <Typography variant="body2" color="black800">
                      12,000
                    </Typography>
                  </td>
                  <td title="可發放額度">
                    <Typography variant="body2" color="primary500">
                      750,000
                    </Typography>
                  </td>
                  {!isDesktop && (
                    <td title="系統設定費">
                      <Typography variant="body2" color="black800">
                        10,000
                      </Typography>
                    </td>
                  )}
                  <td title="總費用">
                    <Typography variant="body2" color="black800">
                      22,000
                    </Typography>
                  </td>
                </tr>
              </tbody>
            </table>
          </Box>
        </Paper>
        <Box
          display="flex"
          marginTop={isDesktop ? '24px' : '16px'}
          flexDirection={isDesktop ? 'row' : 'column'}
        >
          <Box width="100%" marginRight={isDesktop ? '12px' : 0}>
            <Paper height="auto">
              <Chip contained label="功能服務" variant="primary" />
              <Box marginTop="20px">
                <Box
                  width={isDesktop ? '50%' : '100%'}
                  display="inline-block"
                  paddingTop="16px"
                >
                  <Box display="flex" alignItems="center">
                    <svg
                      width="18"
                      height="14"
                      viewBox="0 0 18 14"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M18 2L6 14L0.5 8.5L1.91 7.09L6 11.17L16.59 0.589996L18 2Z"
                        fill="#00821E"
                      />
                    </svg>
                    <Typography variant="title" style={{ marginLeft: 12 }}>
                      管理匯款群組
                    </Typography>
                  </Box>
                </Box>
                <Box
                  width={isDesktop ? '50%' : '100%'}
                  display="inline-block"
                  paddingTop="16px"
                >
                  <Box display="flex" alignItems="center">
                    <svg
                      width="18"
                      height="14"
                      viewBox="0 0 18 14"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M18 2L6 14L0.5 8.5L1.91 7.09L6 11.17L16.59 0.589996L18 2Z"
                        fill="#00821E"
                      />
                    </svg>
                    <Typography variant="title" style={{ marginLeft: 12 }}>
                      專屬企業客服
                    </Typography>
                  </Box>
                </Box>
                <Box
                  width={isDesktop ? '50%' : '100%'}
                  display="inline-block"
                  paddingTop="16px"
                >
                  <Box display="flex" alignItems="center">
                    <svg
                      width="18"
                      height="14"
                      viewBox="0 0 18 14"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M18 2L6 14L0.5 8.5L1.91 7.09L6 11.17L16.59 0.589996L18 2Z"
                        fill="#00821E"
                      />
                    </svg>
                    <Typography variant="title" style={{ marginLeft: 12 }}>
                      匯款後取得發票
                    </Typography>
                  </Box>
                </Box>
                <Box
                  width={isDesktop ? '50%' : '100%'}
                  display="inline-block"
                  paddingTop="16px"
                >
                  <Box display="flex" alignItems="center">
                    <svg
                      width="18"
                      height="14"
                      viewBox="0 0 18 14"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M18 2L6 14L0.5 8.5L1.91 7.09L6 11.17L16.59 0.589996L18 2Z"
                        fill="#00821E"
                      />
                    </svg>
                    <Typography variant="title" style={{ marginLeft: 12 }}>
                      真人系統操作教學
                    </Typography>
                  </Box>
                </Box>
                <Box
                  width={isDesktop ? '50%' : '100%'}
                  display="inline-block"
                  paddingTop="16px"
                >
                  <Box display="flex" alignItems="center">
                    <svg
                      width="18"
                      height="14"
                      viewBox="0 0 18 14"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M18 2L6 14L0.5 8.5L1.91 7.09L6 11.17L16.59 0.589996L18 2Z"
                        fill="#00821E"
                      />
                    </svg>
                    <Typography variant="title" style={{ marginLeft: 12 }}>
                      一鍵支付多人款項
                    </Typography>
                  </Box>
                </Box>
              </Box>
            </Paper>
            <Paper
              style={{ marginTop: isDesktop ? '24px' : '16px' }}
              height="auto"
            >
              {!calc ? (
                <Box>
                  <Typography
                    variant={isDesktop ? 'h4' : 'h5'}
                    color="black900"
                  >
                    不確定如何計費嗎?
                  </Typography>
                  <Typography
                    variant="body2"
                    color="black700"
                    style={{
                      marginTop: '8px',
                    }}
                  >
                    請輸入每個月平均發放勞務報酬的金額，我們會幫您估算費用。
                  </Typography>
                  <Typography
                    variant={isDesktop ? 'h5' : 'h6'}
                    color="black900"
                    style={{
                      marginTop: isDesktop ? '24px' : '16px',
                    }}
                  >
                    每個月平均發放的勞務報酬金額
                  </Typography>
                  <form
                    style={{ marginTop: isDesktop ? '24px' : '16px' }}
                    onSubmit={(e) => {
                      e.preventDefault()
                      console.log('submit...')
                      if (Number(amount) > 0) {
                        setCalc(true)
                      }
                    }}
                  >
                    <TextField
                      onKeyUp={(e: any) => {
                        if (e.keyCode === 13) {
                          e.target.blur()
                        }
                      }}
                      width="100%"
                      fullWidth
                      height={56}
                      placeholder="0"
                      InputProps={{
                        endAdornment: (
                          <span style={{ fontWeight: 700 }}>元</span>
                        ),
                      }}
                      onChange={(e: any) => {
                        if (
                          e.nativeEvent.inputType !== 'insertCompositionText'
                        ) {
                          const value = e.target.value.replace(/\.|,/g, '')
                          if (isNaN(Number(value))) return
                          setAmount(Number(value) < 0 ? 0 : Number(value))
                        }
                      }}
                      value={amount.toLocaleString()}
                    />
                    <Button
                      fullWidth
                      type="submit"
                      variant="secondary"
                      style={{ marginTop: isDesktop ? '24px' : '16px' }}
                      size="large"
                      onClick={() => {}}
                    >
                      計算
                    </Button>
                  </form>
                </Box>
              ) : (
                <Box>
                  <Typography
                    variant={isDesktop ? 'h4' : 'h5'}
                    color="black900"
                  >
                    建議您使用的方案為
                  </Typography>
                  <Box marginTop="24px">
                    <Typography variant="title" color="black800">
                      每月購買 Token
                    </Typography>
                    <Typography variant="body1" color="black800">
                      {Math.ceil(amount / 250000)} 枚
                    </Typography>
                  </Box>
                  <Box marginTop="8px">
                    <Typography variant="title" color="black800">
                      首月費用
                    </Typography>
                    <Typography variant="body1" color="black800">
                      (設定費 10,000 + 使用費{' '}
                      {(Math.ceil(amount / 250000) * 4000).toLocaleString()})
                    </Typography>
                  </Box>
                  <Box marginTop="8px">
                    <Typography variant="title" color="black800">
                      往後費用
                    </Typography>
                    <Typography variant="body1" color="black800">
                      每月{' '}
                      {(Math.ceil(amount / 250000) * 4000).toLocaleString()} 元
                    </Typography>
                  </Box>
                  <Button
                    fullWidth
                    type="submit"
                    variant="secondary"
                    style={{ marginTop: '32px' }}
                    size="large"
                    onClick={() => {
                      setAmount(0)
                      setCalc(false)
                    }}
                  >
                    <Box display="flex" alignItems="center">
                      <svg
                        width="19"
                        height="16"
                        viewBox="0 0 19 16"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M10.8333 0.5C8.84413 0.5 6.93647 1.29018 5.52995 2.6967C4.12343 4.10322 3.33325 6.01088 3.33325 8H0.833252L4.07492 11.2417L4.13325 11.3583L7.49992 8H4.99992C4.99992 6.4529 5.6145 4.96917 6.70846 3.87521C7.80242 2.78125 9.28616 2.16667 10.8333 2.16667C12.3803 2.16667 13.8641 2.78125 14.958 3.87521C16.052 4.96917 16.6666 6.4529 16.6666 8C16.6666 9.5471 16.052 11.0308 14.958 12.1248C13.8641 13.2188 12.3803 13.8333 10.8333 13.8333C9.22492 13.8333 7.76659 13.175 6.71659 12.1167L5.53325 13.3C6.89158 14.6667 8.74992 15.5 10.8333 15.5C12.8224 15.5 14.73 14.7098 16.1366 13.3033C17.5431 11.8968 18.3333 9.98912 18.3333 8C18.3333 6.01088 17.5431 4.10322 16.1366 2.6967C14.73 1.29018 12.8224 0.5 10.8333 0.5Z"
                          fill="#4862CC"
                        />
                      </svg>
                      <span style={{ marginLeft: '6px' }}>重新計算</span>
                    </Box>
                  </Button>
                </Box>
              )}
            </Paper>
          </Box>
          <Box
            width="100%"
            marginLeft={isDesktop ? '12px' : 0}
            marginTop={isDesktop ? 0 : '16px'}
          >
            <Paper height={isDesktop ? 'auto' : 'auto'}>
              <Typography variant={isDesktop ? 'h4' : 'h5'} color="black900">
                聯繫諮詢
              </Typography>
              <Typography
                variant="body2"
                color="black700"
                style={{
                  marginTop: '8px',
                }}
              >
                請留下您的資料，我們會盡快與您聯繫，進一步討論方案內容。
              </Typography>
              {submitBanner && (
                <Banner
                  style={{
                    marginTop: 16,
                  }}
                  variant="success"
                  width="100%"
                >
                  送出成功，我們會盡快聯繫您！
                </Banner>
              )}
              <form
                onSubmit={(e) => {
                  e.preventDefault()
                  handleSubmit()
                }}
              >
                <TextField
                  style={{
                    marginTop: isDesktop ? '24px' : '16px',
                  }}
                  height={56}
                  label="公司名稱 (必填)"
                  fullWidth
                  value={infomation.company}
                  onChange={(e) => {
                    setInfomation({
                      ...infomation,
                      company: e.target.value,
                    })
                  }}
                  disabled={loading}
                  error={verified.company}
                  helperText={verified.company && '公司名稱為必填'}
                />
                <TextField
                  style={{
                    marginTop: isDesktop ? '24px' : '16px',
                  }}
                  height={56}
                  label="聯絡信箱 (必填)"
                  fullWidth
                  value={infomation.email}
                  onChange={(e) => {
                    setInfomation({
                      ...infomation,
                      email: e.target.value,
                    })
                  }}
                  disabled={loading}
                  error={verified.email}
                  helperText={verified.email && '請確認信箱格式是否正確'}
                />
                <TextField
                  style={{
                    marginTop: isDesktop ? '24px' : '16px',
                  }}
                  height={56}
                  label="姓名"
                  fullWidth
                  value={infomation.name}
                  onChange={(e) => {
                    setInfomation({
                      ...infomation,
                      name: e.target.value,
                    })
                  }}
                  disabled={loading}
                />
                <TextField
                  style={{
                    marginTop: isDesktop ? '24px' : '16px',
                  }}
                  height={56}
                  label="職稱"
                  fullWidth
                  value={infomation.role}
                  onChange={(e) => {
                    setInfomation({
                      ...infomation,
                      role: e.target.value,
                    })
                  }}
                  disabled={loading}
                />
                <TextField
                  style={{
                    marginTop: isDesktop ? '24px' : '16px',
                  }}
                  height={56}
                  label="聯絡電話"
                  fullWidth
                  value={infomation.phone}
                  onChange={(e) => {
                    setInfomation({
                      ...infomation,
                      phone: e.target.value,
                    })
                  }}
                  disabled={loading}
                />
                <Button
                  fullWidth
                  type="submit"
                  variant="primary"
                  style={{ marginTop: isDesktop ? '24px' : '16px' }}
                  size="large"
                  disabled={loading}
                  loading={loading}
                  onClick={() => {}}
                >
                  送出
                </Button>
              </form>
            </Paper>
          </Box>
        </Box>

        <Box margin={isDesktop ? '24px 0' : '16px 0'}>
          <Paper height="auto" style={{ paddingBottom: 0 }}>
            <Box
              display="flex"
              flexDirection={isDesktop ? 'row' : 'column'}
              justifyContent="space-between"
            >
              <Box
                padding={isDesktop ? 0 : '16px'}
                minWidth={isDesktop ? '350px' : '200px'}
              >
                <Box
                  display="flex"
                  flexDirection={isDesktop ? 'row' : 'column'}
                >
                  <Box display="flex">
                    <Typography variant="h5" color="black1000">
                      註冊後可享有
                    </Typography>
                    <Typography
                      variant="h5"
                      color="primary400"
                      style={{ margin: '0 6px' }}
                    >
                      50,000元
                    </Typography>
                  </Box>
                  <Box>
                    <Typography variant="h5" color="black1000">
                      的發放額度！
                    </Typography>
                  </Box>
                </Box>
                <Box marginTop="24px">
                  <Button
                    size="large"
                    variant="primary"
                    onClick={() => {
                      setIsOpenAuthModal(true)
                    }}
                  >
                    免費註冊試用
                    <svg
                      width="14"
                      height="14"
                      viewBox="0 0 14 14"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                      style={{ marginLeft: 7 }}
                    >
                      <path
                        d="M0.333313 6.16663V7.8333H10.3333L5.74998 12.4166L6.93331 13.6L13.5333 6.99996L6.93331 0.399963L5.74998 1.5833L10.3333 6.16663H0.333313Z"
                        fill="#FFFFFF"
                      />
                    </svg>
                  </Button>
                </Box>
              </Box>
              <img
                src={userBaseIcon}
                width="100%"
                style={{
                  margin: isDesktop ? '' : '0 auto',
                  alignSelf: isDesktop ? 'flex-end' : '',
                  maxWidth: isDesktop ? '320px' : '360px',
                }}
              />
            </Box>
          </Paper>
        </Box>
      </PricingBlock>
    </Hidden>
  )
}

const PricingWrap = styled.div`
  position: relative;
  overflow: hidden;
  padding-top: 56px;
`

const PricingBlock = styled.div`
  max-width: 902px;
  margin: 0 auto;
  padding: 16px;
  table.price-table {
    width: 100%;
    background-color: #ffffff;
    border-collapse: collapse;
    border-width: 0;
    color: #000;
  }
  table.price-table th {
    background-color: #f9f9f9;
    border-bottom: 1px #ececec solid;
    padding: 14px;
    &:nth-child(n + 2) {
      text-align: left;
    }
  }
  table.price-table td {
    border-top: 1px #ececec solid;
    padding: 17px;
  }
  @media screen and (max-width: 767px) {
    table thead {
      display: none;
    }
    table td {
      display: flex;
      &:first-child {
        background-color: #f9f9f9;
      }
    }

    table td::before {
      content: attr(title);
      font-weight: bold;
      width: 50%;
      min-width: 120px;
    }
  }
`

const PricingItem = styled.div`
  width: 100%;
  height: 84px;
  border: 1px solid #ccc;
  cursor: pointer;
  height: 76px;
  display: flex;
  padding: 16px 24px;
  box-sizing: border-box;
  align-items: center;
  border-radius: 8px;
  justify-content: space-between;
  background-color: white;
`

export default Pricing
